import {layoutCamera, render} from "../sceneManager";

export function enableAllLayers(camera) {
    camera.layers.enableAll();
}

export function disableAllLayers(camera) {
    camera.layers.disableAll();
}

export function disableLayer(camera, layer) {
    camera.layers.disable(layer);
}

export function enableLayerById(camera, layer) {
    camera.layers.enable(layer);
}

export function copyLayersToNewCamera(currentCamera, newCamera) {
    currentCamera.layers.mask = newCamera.layers.mask;
}

//TODO: Für controls anpassen wie layer da reinkommen
export function toggleLayer(camera, id) {
    camera.layers.toggle(parseInt(id));
    render();
}

export function changeChildrenLayer(group, oldLayer, newLayer) {
    for (let i = 0; i < group.children.length; i++) {
        let element = group.children[i];

        if (element.children?.length > 0) {
            changeChildrenLayer(element, oldLayer, newLayer);
        }

        if (element.layers.mask === getMaskFromId(oldLayer)) {
            element.layers.set(newLayer);
        }
    }
}

export function setObjectLayer(object, layer, recursive = false) {
    if (layer === "") {
        return;
    }

    object.layers.set(layer);

    if (recursive && object.children !== undefined) {
        for (let i = object.children.length - 1; i >= 0; i--) {
            let child = object.children[i];
            setObjectLayer(child, layer, recursive);
        }
    }
}

function getMaskFromId(id) {
    return Math.pow(2, id);
}

export function enablePreviewInCamera() {
    layoutCamera.layers.enable(11);
}

export function layerEnabled(camera, layer) {
    return camera.layers.isEnabled(layer);
}
